import * as THREE from 'three';
import { Scene, OrthographicCamera, WebGLRenderer, Vector3, MeshBasicMaterial, SphereGeometry, TorusGeometry, MeshPhongMaterial, DirectionalLight, AmbientLight, Sphere } from 'three';
import bgVert from "../glsl/bg.vert";
import bgFrag2 from "../glsl/bg2.frag";
import { RttSceneBase } from './RttSceneBase';
import { BrushMesh } from '../mat/BrushMesh';
import { Params } from '../data/Params';
import { MyColors } from '../mat/MyColors';

export class RttScene2 extends RttSceneBase{

    scene   :Scene;
    camera  :OrthographicCamera;
    renderTarget    :THREE.WebGLRenderTarget;

    sphere: THREE.Mesh;
    brush: BrushMesh;

    sphereMat: MeshPhongMaterial;
    sphereMat2: MeshBasicMaterial;
    
    
    speed: THREE.Vector3;
    time: number = 0;
    //https://www.pentacreation.com/blog/2021/05/210504.html

    constructor(){
        super();
        
        const planeGeometry = new THREE.PlaneGeometry(2,2,1,1);
        this.material = 
            new THREE.ShaderMaterial({
                uniforms: {
                    time: {value: 1.0},
                    tex1: {value: null},
                    flowMap:{value:null},
                    
                    //dLight:{value:Params.dLight.position},
                    resolution: {value: new THREE.Vector2(
                        1024,1024                     
                    )}
                },
                vertexShader:   bgVert,
                fragmentShader: bgFrag2
            });
        this.sphereMat=new MeshPhongMaterial({
            color:0xffffff
        });
        this.sphereMat2 = new MeshBasicMaterial({
            color: 0xff0000
        });


        this.sphere = new THREE.Mesh(
            //new TorusGeometry(0.5,0.1,10,10),
            new SphereGeometry(0.1,10,10),
            this.sphereMat2
        );
        
        this.brush = new BrushMesh();
        this.scene.add(this.brush);


        let light = new DirectionalLight(0xffffff,0);
        this.scene.add(light)

        let light2 = new AmbientLight(0xffffff);
        this.scene.add(light2)

        this.scene.add(this.sphere);
        this.speed = new Vector3(
            0.02*(Params.random()-0.5),
            0.02*(Params.random()-0.5),
            0.02*(Params.random()-0.5),
        )

        const plane = new THREE.Mesh(
            planeGeometry,
            this.material
        );
        this.scene.add(plane);

        //出力チェック用
        const plane2 = new THREE.Mesh(planeGeometry,new MeshBasicMaterial({
            map:this.renderTarget.texture
        }));
        plane2.scale.set(50,50,50)
        this.add(plane2);        
    }

    override addImpulse(xx:number,yy:number){
        xx = xx - 0.5;
        yy = yy - 0.5;
        if(this.sphere){
            this.sphere.position.set(
                2*xx,
                2*yy,
                0
            );
            this.sphere.visible=false;

            this.brush.position.set(
                2*xx,
                2*yy,
                0
            );

            let col = MyColors.getColor()
            this.brush.update(
                col.r,col.g,col.b
            );
        }


        this.sphereMat2.color.setRGB(
            Params.random(),
            Params.random(),
            Params.random()
        );

    }

    update(renderer:WebGLRenderer){
        
        this.sphere.rotation.x=Params.random()*2*Math.PI;//this.speed.x;
        this.sphere.rotation.y=Params.random()*2*Math.PI;//this.speed.y;
        this.sphere.rotation.z=Params.random()*2*Math.PI;//this.speed.z;



 



        this.time += 0.01;
        if(this.time>10)this.time=0;

        //オフスクリーンレンダリング
        super.update(renderer);
         
    }

}